import {command, query} from "../utils/api";

const GET_TILL_LIMITS_URL = `${process.env.PUBLIC_URL}/api/v1/r/tillLimits`;
export const GET_TILL_LIMITS = 'GET_TILL_LIMITS';
export const GET_TILL_LIMITS_COMPLETED = 'GET_TILL_LIMITS_COMPLETED';
export const GET_TILL_LIMITS_FAILED = 'GET_TILL_LIMITS_FAILED';

export function getTillLimits(payload) {
  const pagination = payload && payload.pagination;
  return query(GET_TILL_LIMITS_URL, {}, GET_TILL_LIMITS, GET_TILL_LIMITS_COMPLETED, GET_TILL_LIMITS_FAILED,
    pagination);
}

const SET_TILL_LIMIT_URL = `${process.env.PUBLIC_URL}/api/v1/tillLimit/setTillLimit`;
export const SET_TILL_LIMIT = 'SET_TILL_LIMIT';
export const SET_TILL_LIMIT_COMPLETED = 'SET_TILL_LIMIT_COMPLETED';
export const SET_TILL_LIMIT_FAILED = 'SET_TILL_LIMIT_FAILED';

export const setTillLimit = command(SET_TILL_LIMIT_URL, SET_TILL_LIMIT, SET_TILL_LIMIT_COMPLETED,
  SET_TILL_LIMIT_FAILED);



// WEBPACK FOOTER //
// ./src/TillLimit/actions.js